import { loader } from 'graphql.macro'

const GraphqlCalls = {
  GET_PRODUCT_QUERY: loader('./get_product_query.graphql'),
}

export default GraphqlCalls
